const InsituPoints = [
  {
    position: [3.2203, 53.2177, 0],
    name: 'K13a',
    source: 'CMEMS',
    startDate: '1979-01-01 00:00:00',
    endDate: '2023-04-01 00:00:00',
  },
];

export default InsituPoints;
